define('plugin/membership/view/MembershipCancellationDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Membership recurring profile cancellation dialog view
     *
     * @class MembershipCancellationDialogView
     */
    return LayoutView.extend({

        template: '#membership_cancellation_dialog_view',
        ui: {
            confirmBtn: '#sb_membership_cancellation_confirm'
        },
        triggers: {
            'click @ui.confirmBtn': {
                'event': 'confirm',
                'preventDefault': false,
                'stopPropagation': false
            }
        }

    });

});
